import { render, staticRenderFns } from "./AffPaymentApp.vue?vue&type=template&id=f0ab0118&scoped=true&"
import script from "./AffPaymentApp.vue?vue&type=script&lang=js&"
export * from "./AffPaymentApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ab0118",
  null
  
)

export default component.exports